module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "chapter"
  }, [_c('section', {
    staticClass: "chapter",
    attrs: {
      "epub:type": "chapter",
      "id": "section_level_h1_01",
      "role": "doc-chapter",
      "title": "PART I: MY IDENTITY CHOICES"
    }
  }, [_c('h1', {
    staticClass: "ct",
    attrs: {
      "id": "d7e164419"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/MacD_ISBN9781418573447_epub_c7_r1#Anch00119",
      "id": "Anch0009"
    }
  }, [_c('b', [_vm._v("PART I")]), _vm._v(" "), _c('br'), _vm._v(" "), _c('br'), _vm._v(" "), _c('span', {
    staticClass: "smallcaps"
  }, [_c('b', [_vm._v("MY IDENTITY CHOICES")])])])])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-36405442","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/MacD_ISBN9781418573447_epub_c12_r1.vue
// module id = 81
// module chunks = 0